<div>
  @for (estado of traspasos | keyvalue; track estado) {
  <div>
    @if (!esVacio(estado.value)) {
    <div>
      <div>Número de transpasos pendientes de {{ traduccionEstados[estado.key] }}:</div>
      <ul>
        @for (traspaso of estado.value | keyvalue; track traspaso) {
        <li>{{ traspaso.value.nombre }} ({{ traspaso.value.numTraspasos }})</li>
        }
      </ul>
    </div>
    }
  </div>
  }
</div>
